import { mapActions } from "vuex";

export default {
    methods: {
        ...mapActions({
            getTenantConfigList: "tenant/getUpdatedTenantConfigList",
        }),
        initializeSortDataAndSignalR(id) {
            this.signalRTenantConfig(`tenant_config_${this.selectedTenant}`, id);
            this.defaultSortOrder = this.getDefaultSortOrder(id);
        },
        getDefaultSortOrder(id) {
            const tenantConfig = this.tenantSettingConfig("defaultSortOrder");
            if (tenantConfig) {
                const defaultSortOrder = tenantConfig["defaultSortOrder"];
                const item = defaultSortOrder.find(
                    (d) => d.id === id
                );
                if (item) {
                    return { sortOnColumn: item.sortOnColumn, sortType: item.sortType };
                }
            }
            return { sortOnColumn: "datetime", sortType: "desc" };
        },
        async signalRTenantConfig(target, id) {
            await this.signalConnection.on(target, async (message) => {
                await this.getTenantConfigList();
                this.defaultSortOrder = this.getDefaultSortOrder(id);
            });
            if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
                this.signalConnection.start().catch();
            }
        }
    }
}